<template>
    <span :class="classes"
        class="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-semibold tw-border tw-border-solid">
        <span class="tw-w-1.5 tw-h-1.5 tw-rounded-full" :class="dotClass"></span>
        {{ $t('portal.payment.' + (status || 'pending')) }}
    </span>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
    status: { type: String, default: 'pending' },
});

const map = {
    paid: 'tw-bg-emerald-50 tw-text-emerald-700 tw-border-emerald-200',
    pending: 'tw-bg-amber-50 tw-text-amber-700 tw-border-amber-200',
    refunded: 'tw-bg-rose-50 tw-text-rose-700 tw-border-rose-200',
};

const dots = {
    paid: 'tw-bg-emerald-500',
    pending: 'tw-bg-amber-500',
    refunded: 'tw-bg-rose-500',
};

const classes = computed(() => map[props.status] || map.pending);
const dotClass = computed(() => dots[props.status] || dots.pending);
</script>
